import React from 'react'
import { Screen } from '~common/screen'
import { StyledScreen } from '~common/screen'
import UnionIcon from '~images/chats-page/union.svg'

const OmnichannelResults = () => {
  return (
    <Screen
      title={<span><StyledScreen.GreenText>Результат</StyledScreen.GreenText> внедрения омниканальной платформы <br /> нашему клиенту</span>}
      bottomLine
      className='omnichannel-results'
    >
      <div className="omnichannel-results__container">
        <div className="omnichannel-results__row">
          <div className="omnichannel-results__coll">
            <div className="omnichannel-results__coll-label">До внедрения</div>
            <ul className='omnichannel-results__coll-text'>
              <li>5 менеджеров с корпоративными сим-картами</li>
              <li>отчетность со слов менеджеров</li>
              <li>РОП не верит в эффективность продаж через чаты</li>
            </ul>
          </div>
          <div className="omnichannel-results__coll">
            <div className="omnichannel-results__coll-label">После внедрения телефонии и чатов:</div>
            <ul className='omnichannel-results__coll-text'>
              <li>на 50% больше — оказалось реальное количество лидов</li>
              <li>до 10 минут — сократился срок отчета</li>
              <li>стало удобно передавать дела коллегам</li>
              <li>РОП поменял мнение об эффективности продаж в чатах</li>
            </ul>
          </div>
          <div className="omnichannel-results__arrow"><UnionIcon /></div>
        </div>
      </div>
    </Screen>
  );
};

export default OmnichannelResults